import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUtensils, faWifi, faSnowflake, faParking } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from 'react-i18next';

const servicesData = [
    {
        icon: faUtensils,
        titleKey: "services.breakfast.title",
        descriptionKey: "services.breakfast.description",
    },
    {
        icon: faWifi,
        titleKey: "services.wifi.title",
        descriptionKey: "services.wifi.description",
    },
    {
        icon: faSnowflake,
        titleKey: "services.aircon.title",
        descriptionKey: "services.aircon.description",
    },
    {
        icon: faParking,
        titleKey: "services.parking.title",
        descriptionKey: "services.parking.description",
    },
];

function Services() {
    const { t } = useTranslation();
    
    return (
        <section className="services sec-width" id="services">
            <div className="title">
                <h2>{t('services.title')}</h2>
            </div>
            <div className="services-container">
                {servicesData.map((service, index) => (
                    <article className="service" key={index}>
                        <div className="service-icon">
              <span>
                <FontAwesomeIcon icon={service.icon} />
              </span>
                        </div>
                        <div className="service-content">
                            <h2>{t(service.titleKey)}</h2>
                            <p>{t(service.descriptionKey)}</p>
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
}

export default Services;
